<template>
  <v-container pa-4 v-if="this.step !== null">
    <v-layout mb-6>
      <v-flex xs4>
        <v-btn block :disabled="step === 0" @click="previousQuestion">
          Anterior
        </v-btn>
      </v-flex>
      <v-spacer></v-spacer>
      <v-flex xs4>
        <v-btn block :disabled="!nextStep" @click="nextQuestionHandler" :loading="loading">
          Próximo
        </v-btn>
      </v-flex>
    </v-layout>
    <v-layout>
      <v-flex xs12>
        <FormFields @next="nextQuestionHandler"/>
      </v-flex>
    </v-layout>
  </v-container>
  <v-container pa-4 v-else>
    <v-layout mb-6 row wrap class="text-center">
      <v-flex xs12 mt-10>
        <h2>
          Questionário Abracom
        </h2>
      </v-flex>
      <v-flex xs12 mt-5>
        <v-btn text color="primary" @click="startForm()" large>
          Iniciar
        </v-btn>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import FormFields from '../components/Form'
import { mapGetters, mapMutations } from 'vuex'
import axios from 'axios'
export default {
  name: 'Home',
  components: {
    FormFields
  },
  data () {
    return {
      loading: false
    }
  },
  methods: {
    ...mapMutations('form', ['nextQuestion', 'previousQuestion', 'startForm']),
    async nextQuestionHandler () {
      if (this.step === 0) {
        this.loading = true
        try {
          if (/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/.test(this.questions[0].value)) {
            const { data: result } = await axios.get(`GetEmailExiste?email=${this.questions[0].value}`)
            this.loading = false
            if (result) {
              this.$store.commit('snackbar/show', {
                text: 'Email já cadastrado',
                color: 'error'
              })
              return
            }
          } else {
            this.$store.commit('snackbar/show', {
              text: 'Insira um email válido',
              color: 'error'
            })
            this.loading = false
            return
          }
        } catch (error) {
          this.loading = false

          this.$store.commit('snackbar/show', {
            text: 'Erro interno, tente novamente',
            color: 'error'
          })
          return
        }
      }
      if (!this.lastStep) {
        this.nextQuestion()
      } else {
        this.$router.push('finalizar')
      }
    }
  },
  computed: {
    ...mapGetters('form', ['lastStep', 'step', 'nextStep', 'questions'])
  }
}
</script>
